
let baseURL
if (process.env.VUE_APP_ENV === 'serve') {
  baseURL = 'http://192.168.105.47:8080'
  // baseURL = 'https://gateway-dev.zxca.cn'
} else if (process.env.VUE_APP_ENV === 'pre') {
  baseURL = 'https://gateway.cloudsecca.com'
} else if (process.env.VUE_APP_ENV === 'dev') {
  baseURL = 'https://gateway-dev.zxca.cn'
} else if (process.env.VUE_APP_ENV === 'test') {
  baseURL = 'https://gateway-test.zxca.cn'
} else if (process.env.VUE_APP_ENV === 'prod') {
  baseURL = 'https://gateway.zxca.cn'
} else if (process.env.VUE_APP_ENV === 'dist') {
  baseURL = CONFIGD.baseURL
}

export default {
  baseURL
}